import { Drawer, Button } from '@mui/material';

interface BottomTwoBtnDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  leftBtnText?: string;
  rightBtnText?: string;
  leftBtnClick: () => void;
  rightBtnClick: () => void;
}

function BottomTwoBtnDialog({
  open,
  onClose,
  title,
  description,
  leftBtnText = 'Cancel',
  rightBtnText = 'Confirm',
  leftBtnClick,
  rightBtnClick,
}: BottomTwoBtnDialogProps) {
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick') return;
        onClose();
      }}
      PaperProps={{ sx: { borderRadius: '10px 10px 0 0' } }}
      sx={{ zIndex: 9999 }}
    >
      <div className="w-full p-[20px] pb-[40px] text-[#1C1C1C] font-['Pretendard'] flex flex-col items-center justify-between bg-white overflow-hidden">
        <div className="w-full text-center text-[#1C1C1C] text-[18px] font-[600] mt-[20px] mb-[12px]">
          {title.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i === 0 && <br />}
            </span>
          ))}
        </div>
        <div className="w-full text-center text-[14px] text-[#767676] font-[400] mb-[30px] break-keep">
          {description.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i === 0 && <br />}
            </span>
          ))}
        </div>
        <div className="w-full flex items-center justify-between gap-[8px]">
          <Button
            variant="outlined"
            onClick={leftBtnClick}
            className="flex-1 h-[56px] rounded-[8px] bg-[#F8F8F8] text-[#969696] border-none"
            sx={{
              backgroundColor: '#F8F8F8 !important',
              color: '#969696 !important',
              border: 'none !important',
            }}
          >
            {leftBtnText}
          </Button>
          <Button variant="contained" onClick={rightBtnClick} className="flex-1 h-[56px] rounded-[8px]">
            {rightBtnText}
          </Button>
        </div>
      </div>
    </Drawer>
  );
}

export default BottomTwoBtnDialog;
